import Wrapper from './Wrapper.vue';

const Baskets = () => import('./_views/baskets');
const Basket = () => import('./_views/basket');

const parentRouteConfig = {
  name: 'Baskets',
  to: {
    name: 'baskets',
    query: {
      suffix: '',
      pageNum: '1',
    },
  },
};

export default [
  {
    path: '/baskets',
    component: Wrapper,
    children: [
      {
        path: '',
        name: 'baskets',
        component: Baskets,
        meta: {
          title: 'Baskets',
          navigation: {
            position: 4,
            name: 'Baskets',
            icon: 'shopping_basket',
            specialQueries: ['suffix'],
            to: {
              name: 'baskets',
              query: {
                suffix: '',
                pageNum: '1',
              },
            },
          },
        },
      },
      {
        path: ':id',
        name: 'basket',
        component: Basket,
        meta: {
          title: 'Basket Details',
          enableSetSuffix: true,
          parent: parentRouteConfig,
        },
      },
    ],
  },
];
